import React, { useEffect } from 'react';
import './AssignmentCompletionModal.css';

export default function AssignmentCompletionModal({
  open,
  assignment,
  action,          // 'complete' | 'incomplete'
  loading = false,
  onConfirm,
  onClose
}) {
  // Keep hook always
  useEffect(() => {
    if (!open) return;
    const esc = (e) => e.key === 'Escape' && !loading && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [open, loading, onClose]);

  if (!open) return null;

  const isComplete = action === 'complete';
  const title = isComplete ? 'Mark Assignment Complete?' : 'Mark Assignment Incomplete?';
  const message = isComplete
    ? 'Do you want to mark this assignment as completed?'
    : 'Do you want to mark this assignment as not completed?';

  return (
    <div className="acm-backdrop" role="dialog" aria-modal="true">
      <div className="acm-modal">
        <h3 className="acm-title">{title}</h3>
        <p className="acm-assignment">{assignment?.title || assignment?.name}</p>
        <p className="acm-message">{message}</p>
        <div className="acm-actions">
          <button
            className="btn-secondary acm-btn"
            type="button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className={`btn-primary acm-btn ${!isComplete ? 'danger' : ''}`}
            type="button"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Updating...' : (isComplete ? 'Yes, Mark Complete' : 'Yes, Mark Incomplete')}
          </button>
        </div>
      </div>
    </div>
  );
}